import { TypeAsserter, TypeChecker } from '@attain-apps/type-guards'

/**
 * Various display elements have different aesthetics for each of these styles
 */
export enum Style {
  Success = 'success',
  Error = 'error',
  Warning = 'warning',
  Info = 'info',
}
// Needs to be before namespace is defined
const STYLES: ReadonlySet<Style> = new Set(Object.values(Style) as Style[])
export namespace Style {
  export const ALL: readonly Style[] = Array.from(STYLES)
  export const isStyle = TypeChecker.Factory.oneOf(STYLES)
  export const assertIsStyle: TypeAsserter<Style> =
    TypeAsserter.Factory.from(isStyle)

  /**
   * Represents a display element that has a {@link Style}
   */
  export interface Holder {
    style: Style
  }
}
